<template>
  <div
    v-if="componentReady"
    class="questionnaire"
  >
    <div class="questionnaire-top">
      <b-row>
        <b-col
          cols="12"
          class="header"
        >
          <h4>
            {{ currentForm.name }}
          </h4>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          v-if="!testSubmitted"
          cols="12"
        >
          <b-row>
            <b-col cols="12">
              <b-form>
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                  >
                    {{ questionPartOne.question }}

                    <b-form-datepicker
                      id="example-datepicker"
                      v-model="responses[questionPartOne.id]"
                      class="mb-2"
                    />
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                  >
                    {{ questionPartTwo.question }}
                    <b-form-timepicker
                      v-model="responses[questionPartTwo.id]"
                      locale="en"
                    />
                  </b-col>
                </b-form-row>
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form>
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                  >
                    {{ questionPartThree.question }}
                    <span v-if="questionPartThree.type === undefined || questionPartThree.type ==='text'">
                      <b-form-input
                        size="lg"
                        type="text"
                        v-model="responses[questionPartThree.id]"
                      />
                    </span>
                    <span v-else-if="questionPartThree.type ==='number'">
                      <b-form-input
                        size="lg"
                        type="number"
                        v-model="responses[questionPartThree.id]"
                      />
                    </span>
                    <span v-else-if="questionPartThree.type ==='select'">
                      <b-form-select
                        size="lg"
                        :options="questionPartThree.values"
                        v-model="responses[questionPartThree.id]"
                      />
                    </span>
                    <span v-else-if="questionPartThree.type ==='checkbox'">
                      <b-form-checkbox-group
                        class="question-checkboxes"
                        size="lg"
                        stacked
                        :options="questionPartThree.values"
                        v-model="responses[questionPartThree.id]"
                      />
                    </span>
                    <span v-else-if="questionPartThree.type ==='radio'">
                      <b-form-radio-group
                        class="question-radio"
                        size="lg"
                        :options="questionPartThree.values"
                        v-model="responses[questionPartThree.id]"
                      />
                    </span>
                    <span v-else>
                      <b-form-input
                        size="lg"
                        type="text"
                        v-model="responses[questionPartThree.id]"
                      />
                    </span>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                  >
                    {{ questionPartFour.question }}
                    <span v-if="questionPartFour.type === undefined || questionPartFour.type ==='text'">
                      <b-form-input
                        size="lg"
                        type="text"
                        v-model="responses[questionPartFour.id]"
                      />
                    </span>
                    <span v-else-if="questionPartFour.type ==='number'">
                      <b-form-input
                        size="lg"
                        type="number"
                        v-model="responses[questionPartFour.id]"
                      />
                    </span>
                    <span v-else-if="questionPartFour.type ==='select'">
                      <b-form-select
                        size="lg"
                        :options="questionPartFour.values"
                        v-model="responses[questionPartFour.id]"
                      />
                    </span>
                    <span v-else-if="questionPartFour.type ==='checkbox'">
                      <b-form-checkbox-group
                        class="question-checkboxes"
                        size="lg"
                        stacked
                        :options="questionPartFour.values"
                        v-model="responses[questionPartFour.id]"
                      />
                    </span>
                    <span v-else-if="questionPartFour.type ==='radio'">
                      <b-form-radio-group
                        class="question-radio"
                        size="lg"
                        :options="questionPartFour.values"
                        v-model="responses[questionPartFour.id]"
                      />
                    </span>
                    <span v-else>
                      <b-form-input
                        size="lg"
                        type="text"
                        v-model="responses[questionPartFour.id]"
                      />
                    </span>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          v-if="testSubmitted"
          cols="12"
          class="results"
        >
          <span v-if="responses[10] <= 2">
            <img
              src="../assets/stop-sign.png"
            >
          </span>

          <span v-if="responses[10] > 2 && responses[10] < 5">
            Welcome
          </span>

          <span v-if="responses[10] == 5">
            Invalid
          </span>
        </b-col>
      </b-row>
    </div>

    <div class="questionnaire-bottom">
      <b-row>
        <b-col cols="12">
          <b-form>
            <b-form-row class="question-navigation">
              <b-col
                cols="12"
                class="pb-3 question-navigation"
              >
                <b-button
                  v-if="testSubmitted"
                  @click="logout"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/log-out-icon.png"
                    class="logout"
                  >
                </b-button>

                <b-button
                  v-if="testSubmitted"
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/screening-icon.png"
                    class="screening-icon"
                  >
                </b-button>

                <b-button
                  v-if="!testSubmitted"
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                  >
                </b-button>

                <b-button
                  @click="availableForms"
                  class="btn-green btn-nav"
                >
                  <b-icon-arrow-left />
                </b-button>

                <b-button
                  @click.stop.prevent="submitForm"
                  class="btn-green btn-nav"
                  :disabled="!canSubmitForm"
                >
                  <b-icon-check />
                </b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { routes } from '../router/routes'

export default {
  middleware: 'auth',
  name: 'Covid19Test',
  props: {
    questionnaireId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      componentReady: false,
      testSubmitted: false,
      currentPage: 1,
      myRoute: {},
      responses: [],
      dateTaken: '',
      timeTaken: ''
    }
  },
  mounted () {
    const date = new Date()
    const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric' })
    const [{ value: month },, { value: day },, { value: year },, { value: hour },, { value: minute }] = dateTimeFormat.formatToParts(date)

    this.myRoute = routes.find(route => route.name === this.$router.currentRoute.name)
    this.questions.forEach(question => {
      if (question.type === 'checkbox' || question.type === 'select') {
        this.responses[question.id] = []
      } else {
        if (question.id === 7) {
          this.responses[question.id] = year + '-' + month + '-' + day
        } else {
          this.responses[question.id] = hour + ':' + minute + ':00'
        }
      }
    })

    this.componentReady = true
  },
  computed: {
    ...mapGetters({
      questionnaires: 'forms/questionnaires'
    }),
    currentForm () {
      return this.questionnaires.find(questionnaire => questionnaire.id === this.questionnaireId)
    },
    questions () {
      return this.currentForm.questions
    },
    questionPartOne () {
      return this.questions[0]
    },
    questionPartTwo () {
      return this.questions[1]
    },
    questionPartThree () {
      return this.questions[2]
    },
    questionPartFour () {
      return this.questions[3]
    },
    canSubmitForm () {
      return this.responses[9].length !== 0 && this.responses[10].length !== 0
    }
  },
  methods: {
    submitForm () {
      this.testSubmitted = !this.testSubmitted
      console.log(this.responses)
    }
  }
}
</script>

<style scoped lang="scss">
.questionnaire-top {
  // height: 50vh;
}

.questionnaire-bottom {
  // height: 30vh;
  text-align: center;
}

.results {
  text-align: center;
}
</style>
